import { Swiper } from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export function initSwiperNews() {
  const swiper = new Swiper(".news__slider .swiper", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return (
          'Показано <span class="' +
          currentClass +
          '"></span>' +
          " из " +
          '<span class="' +
          totalClass +
          '"></span>'
        );
      },
    },

    breakpoints: {
      280: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
      },
      350: {
        slidesPerView: 1.1,
      },
      680: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      },
      1160: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      1500: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
      },
    },
  });

  return swiper;
}
